import { ArrowRight, ChevronLeft, ChevronRight } from "lucide-react";
import { useEffect, useState } from "react";
import "./LandingHeroCarousel.css";

type Slide = {
    eyebrow: string;
    title: string;
    description: string;
    primaryAction: string;
    secondaryAction: string;
    image: string;
};

const slides: Slide[] = [
    {
        eyebrow: "WELCOME TO SALAR",
        title: "Everything you love, all in one place.",
        description: "Discover fashion, electronics, lifestyle essentials and everyday favourites through one seamless shopping experience.",
        primaryAction: "Start Shopping",
        secondaryAction: "Explore Categories",
        image: "https://unicart.et/cdn/shop/files/premium-e-commerce-banner-featuring-fashion-and-tech-products-leather-bags-men-s-shoes-eyeglasses-phone-cases-smart-wallets-modern-watches-and-girls-accessories-subtly-included-minima.png?v=1767076548&width=2000",
    },
    {
        eyebrow: "DISCOVER YOUR STYLE",
        title: "Find something made for your lifestyle.",
        description: "Explore thoughtfully selected fashion, accessories and trending products designed around the way you live and shop.",
        primaryAction: "Explore Collection",
        secondaryAction: "View New Arrivals",
        image: "https://www.rhei.it/hubfs/NSP_image_fashion.png",
    },
    {
        eyebrow: "SMARTER EVERYDAY SHOPPING",
        title: "From everyday essentials to premium finds.",
        description: "Shop lifestyle, technology, beauty and personal essentials with better choice, convenience and value at every step.",
        primaryAction: "Shop Now",
        secondaryAction: "Discover More",
        image: "https://www.bringitonline.in/uploads/2/2/4/5/22456530/product-photography-online-store-delhi-ncr-mumbai-product-photography-online-store-india-onp_orig.png",
    },
];

const LandingHeroCarousel = () => {
    const [activeSlide, setActiveSlide] = useState(0);
    const [isPaused, setIsPaused] = useState(false);
    useEffect(() => {
        if (isPaused) return;
        const interval = window.setInterval(() => {
            setActiveSlide((prev) => (prev + 1) % slides.length);
        }, 5500);
        return () => window.clearInterval(interval);
    }, [isPaused]);
    const goToPrevious = () => {
        setActiveSlide((prev) => (prev - 1 + slides.length) % slides.length);
    };
    const goToNext = () => {
        setActiveSlide((prev) => (prev + 1) % slides.length);
    };
    return (
        <section
            className="landing-hero-carousel"
            onMouseEnter={() => setIsPaused(true)}
            onMouseLeave={() => setIsPaused(false)}>
            <div className="landing-carousel-slides">
                {slides.map((slide, index) => (
                    <article key={slide.title} className={`landing-carousel-slide ${index === activeSlide ? "active" : ""}`}>
                        <div className="landing-carousel-media">
                            <img src={slide.image} alt={slide.title} className="landing-carousel-image" />
                        </div>
                        <div className="landing-carousel-overlay" />
                        <div className="landing-carousel-content">
                            <span className="landing-carousel-eyebrow">
                                <span className="landing-carousel-eyebrow-line" /> {slide.eyebrow}
                            </span>
                            <h1>{slide.title}</h1>
                            <p>{slide.description}</p>
                            <div className="landing-carousel-actions">
                                <button type="button" className="landing-carousel-primary">
                                    {slide.primaryAction}
                                    <ArrowRight size={16} strokeWidth={1.8} />
                                </button>
                                <button type="button" className="landing-carousel-secondary">
                                    {slide.secondaryAction}
                                </button>
                            </div>
                        </div>
                    </article>
                ))}
            </div>

            <div className="landing-carousel-navigation">
                <button type="button" className="landing-carousel-arrow" onClick={goToPrevious} aria-label="Previous slide">
                    <ChevronLeft size={19} strokeWidth={1.8} />
                </button>
                <div className="landing-carousel-pagination">
                    {slides.map((slide, index) => (
                        <button type="button" key={slide.title}
                            className={`landing-carousel-pagination-item ${index === activeSlide ? "active" : ""}`}
                            onClick={() => setActiveSlide(index)} aria-label={`Go to slide ${index + 1}`}>
                            <span className="landing-carousel-pagination-number"> 0{index + 1} </span>
                            <span className="landing-carousel-progress">  <span /> </span>
                        </button>
                    ))}
                </div>
                <button type="button" className="landing-carousel-arrow" onClick={goToNext} aria-label="Next slide">
                    <ChevronRight size={19} strokeWidth={1.8} />
                </button>
            </div>
        </section>
    );
};
export default LandingHeroCarousel;